import styled from "styled-components";
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useState } from "react";
import { TextInputWTitle } from "../Inputs/TextInputWTitle";
import { useSnackbar } from "notistack";
import { TextBtn2 } from "../Inputs/TextBtn2";
import { Dictionery } from "../../Data/Dictionery";
import { PostDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";

const Style = styled.div`
    max-width: 440px;
    min-height: 150px;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .pad {
        margin: 1rem 0 0;
    }
    .pad-btm {
        margin-bottom: 0.5rem;
    }
    .login-email {
        margin: 0rem 0 1rem;
        text-decoration: none;
        font-weight: 600;
    }
    .row {
        align-items: center;
        display: flex;
        gap: 0.7rem;
    }
    @media screen and (max-width: 850px) {
        max-width: none;
        .row {
            flex-direction: column;
            gap: 0;
        }
    }
`;
export default function FormPanLogin(props){
    const { enqueueSnackbar } = useSnackbar();

    const [dialogLoading, setDialogLoading] = useState(false);
    const [dialogError, setDialogError] = useState({});
    const [data, setData] = useState((props.dialogData) ? props.dialogData : {});
    const [step, setStep] = useState(1);
    const onChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        let temp = {...data};
        temp[name] = value;
        setData(temp);
    }

    const sendUpdate = async (e) => {
        if(step === 1){
            step1Send(e);
        }
        if(step === 2){
            step2Send(e);
        }   
    }
    const step1Send = async (e) => {
        // user_disposable
        setDialogLoading(true);
        let formData = new FormData();
        if(!data.U_MOBILE || data.U_MOBILE === ""){
            setDialogLoading(false);
            setDialogError({U_MOBILE: "شماره موبایل الزامی است"})
            return;
        }
        formData.append("U_MOBILE", data.U_MOBILE);
        if(localStorage.getItem("luxintrip-invite-code")){
            formData.append("INVITE_CODE", localStorage.getItem("luxintrip-invite-code"));
        }
        let response = await PostDataPromise(apiMain + "/api/v1/user/user_disposable", formData);
        let parsed = JSON.parse(response);
        if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
            setStep(2);
        }
        setDialogLoading(false);
    }
    const step2Send = async (e) => {
        // user_login_mobile
        setDialogLoading(true);
        let formData = new FormData();
        formData.append("U_MOBILE", data.U_MOBILE);
        if(!data.U_Disposable || data.U_Disposable === ""){
            setDialogLoading(false);
            setDialogError({U_Disposable: "کد تایید الزامی است"})
            return;
        }
        formData.append("U_Disposable", data.U_Disposable);
        let response = await PostDataPromise(apiMain + "/api/v1/user/user_login_mobile", formData);
        let parsed = JSON.parse(response);
        if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
            const userdata =  {
                ...parsed.data,
                permission: parsed.permission,
            };
            localStorage.setItem("luxtrip-user", JSON.stringify(userdata));
            props.setUser(userdata);
            props.save();
            if(typeof props.dialogCallback.func === "function"){
                props.dialogCallback.func();
                props.setDialogCallback({})
            }
        }
        setDialogLoading(false);
    }
    return(
        <>
            <DialogContent sx={{display: "flex", flexDirection: "column", direction: ((props.lang !== "fa") ? "rtl" : "ltr")}}>
                <Style>
                    {
                        (step === 1) ? (
                            <>
                            <TextInputWTitle
                                title={Dictionery.loginSignupMobile[props.lang]}
                                name={"U_MOBILE"}
                                value={(data.U_MOBILE) ? data.U_MOBILE : ""}
                                first={true}
                                onchange={onChange}
                                error={(dialogError.U_MOBILE) ? dialogError.U_MOBILE : ""}
                                lan={(props.lang !== "fa") ? true : false}
                            />
                            <div className="pad"></div>
                            <a className="login-email" href={"/login"}>{Dictionery.loginSignupWithEmail[props.lang]}</a>
                            </>
                        ) : (
                            <>
                            <div className="pad-btm">
                                {Dictionery.loginSignupVerifyText1[props.lang]}
                                {(data.U_MOBILE) ? data.U_MOBILE : ""}
                                {Dictionery.loginSignupVerifyText2[props.lang]}
                            </div>
                            <TextInputWTitle
                                title={Dictionery.loginSignupVerifyCode[props.lang]}
                                name={"U_Disposable"}
                                value={(data.U_Disposable) ? data.U_Disposable : ""}
                                first={true}
                                onchange={onChange}
                                error={""}
                                lan={(props.lang !== "fa") ? true : false}
                            />
                            </>
                        )
                    }
                </Style>
            </DialogContent>
            <DialogActions sx={{margin: "0 16px 12px"}}>
                <TextBtn2 
                    text={
                        (step === 1) ? 
                        Dictionery.loginSignupSendCode[props.lang] : 
                        Dictionery.loginSignup[props.lang]
                    }
                    disabled={dialogLoading} 
                    loading={dialogLoading}
                    onclick={sendUpdate} 
                    newType={2}
                />
            </DialogActions>
        </>
    )
}